import React, { useContext } from "react";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "../common/context/AdvancedOptions";
const FormAdvancedOptions = ({ onChange, selectedContentTypes = "" }) => {
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { symantecSESThrottleEnabled, streamConnectionTimeout } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  return /* @__PURE__ */ React.createElement(AdditionalFields, { title: "Advanced Options", visible: isAdvancedOptionsVisible, onToggle: handleToggle }, /* @__PURE__ */ React.createElement(
    ThrottlingCheckbox,
    {
      id: "symantecSESThrottleEnabled",
      defaultChecked: symantecSESThrottleEnabled == null ? void 0 : symantecSESThrottleEnabled.value,
      onChange
    }
  ), (selectedContentTypes === "events" || selectedContentTypes === "events,incidents" || selectedContentTypes === "incidents,events") && /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "streamConnectionTimeout",
      name: "streamConnectionTimeout",
      type: "number",
      value: streamConnectionTimeout.value || streamConnectionTimeout.defaultValue || "",
      min: "1",
      max: "60",
      step: "1",
      onChange,
      required: true,
      help: "Event stream connection timeout in minutes, indicates how long the stream connection should be available.",
      label: "Event Stream Connection Timeout"
    }
  ));
};
export default FormAdvancedOptions;
